import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackageTagsComponent } from './package-tags.component';

@NgModule({
    imports: [SharedModule],
    declarations: [PackageTagsComponent],
    entryComponents: [PackageTagsComponent],
    exports: [PackageTagsComponent]
})
export class PackageTagsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/package-tags/package-tags.module.ts